module.exports = __webpack_public_path__ + "img/traffic-light.6226ebc4.svg";